module.exports = __webpack_public_path__ + "assets/create-algae-green.2f5f1d1d34b5728e12d0c7a62a504141.svg";